<script setup lang="ts">
import type { CommandItemProps } from "ls/components/command";
import type { RouteLocationRaw } from "vue-router";
import { reactiveOmit } from "@vueuse/core";
import { CommandItem } from "ls/components/command";
import { withoutTrailingSlash } from "ufo";
import { RouterLink } from "vue-router";
import SearchHighlight from "./SearchHighlight.vue";

const props = defineProps<CommandItemProps & {
  taggedTitle: string;
  path?: string;
  href?: RouteLocationRaw;
  taggedHighlight?: string;
}>();

const omitProps = reactiveOmit(props, ["taggedTitle", "path", "href"]);
</script>

<script lang="ts">
function handleClick(event: MouseEvent) {
  // stop bubbling click event if trying to open in a new tab
  // in this case @select event won't be triggered on CommandItem
  if (event.ctrlKey || event.metaKey || event.button === 1 /* wheel click */) {
    event.stopPropagation();
  }
}
</script>

<template>
  <CommandItem class="group/command" v-bind="omitProps">
    <component
      :is="href ? RouterLink : 'div'"
      :to="href"
      class="flex min-w-0 flex-1 flex-row items-center gap-2 px-2 py-1"
      @click="handleClick"
    >
      <div class="relative top-0.75 flex flex-none self-start">
        <slot name="icon" />
      </div>
      <div class="overflow-hidden">
        <SearchHighlight
          :tagged-text="taggedTitle"
          class="truncate"
        />
        <div v-if="path && path.trim() !== '/'" class="truncate text-xs text-slate-500">
          {{ withoutTrailingSlash(path) }}
        </div>
        <SearchHighlight
          v-if="taggedHighlight"
          :tagged-text="taggedHighlight"
          class="truncate"
        />
      </div>
      <slot />
    </component>
  </CommandItem>
</template>
